import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "reactstrap";
import { Dropdown } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import { tableHeader } from "../../../constants/campaigns";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import actions, { useActions } from "../../../redux/actions";
import Portal from "./portal";
import themeColor from "../../../styles/themeColor";

const ActionDropdown = (props) => {
  const campaignActions = useActions(actions.CampaignActions);
  const { t } = useTranslation();
  const { setShowModal, setAlert, campaign, isUpdateAllowed } = props;

  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle className="btn btn-sm">{t("option")}</Dropdown.Toggle>
        {isUpdateAllowed ? (
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                campaignActions.select(campaign);
                setShowModal(true);
              }}
            >
              {t("edit")}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                campaignActions.select(campaign);
                setAlert({
                  ...alert,
                  content: t("removeRecord"),
                  show: true,
                  type: "default",
                });
              }}
            >
              {t("remove")}
            </Dropdown.Item>
          </Dropdown.Menu>
        ) : (
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                campaignActions.select(campaign);
                setShowModal(true);
              }}
            >
              {t("view")}
            </Dropdown.Item>
          </Dropdown.Menu>
        )}
      </Dropdown>
    </div>
  );
};

const CampaignsList = (props) => {
  const { t, i18n } = useTranslation();
  const { campaigns } = props;
  const account = useSelector((state) => state.account);
  const [campaignList, setCampaignList] = useState(campaigns);
  const campaign = useSelector((state) => state.campaign);
  const campaignActions = useActions(actions.CampaignActions);
  const [showModal, setShowModal] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    title: "",
    type: "default",
    content: "",
  });
  const [isCreateAllowed, setIsCreateAllowed] = useState(false);
  const [isUpdateAllowed, setIsUpdateAllowed] = useState(false);

  const handleCloseAlert = () => {
    setAlert({ ...alert, show: false });
    window.location.reload();
  };

  const handleShowModal = () => {
    setShowModal(!showModal);
  };
  const handleRemove = () => {
    campaignActions.remove(
      campaign.selected._id,
      account.token,
      () => {
        setAlert({
          ...alert,
          show: true,
          title: t("success"),
          content: "",
          type: "success",
        });
      },
      () => {
        setAlert({
          ...alert,
          show: true,
          title: t("error"),
          content: "",
          type: "error",
        });
      }
    );
  };

  useEffect(() => {
    setCampaignList(campaigns);
  }, [campaigns]);

  useEffect(() => {
    if (
      account.permission.general.includes("campaign-create") ||
      account.permission.general.includes("*")
    )
      setIsCreateAllowed(true);
    if (
      account.permission.general.includes("campaign-update") ||
      account.permission.general.includes("*")
    )
      setIsUpdateAllowed(true);
  }, []);

  return (
    <div style={{ overflow: "auto" }}>
      {isCreateAllowed && (
        <button
          type="button"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
          onClick={() => {
            campaignActions.select(null);
            handleShowModal();
          }}
        >
          {t("add")}
        </button>
      )}
      <SweetAlert
        show={alert.show}
        type={alert.type}
        title={alert.title}
        onConfirm={campaign.selected._id ? handleRemove : handleCloseAlert}
        onCancel={handleCloseAlert}
        showCancel={campaign.selected._id}
        cancelBtnCssClass="btn btn-light"
        cancelBtnStyle={{ color: themeColor.black }}
        confirmBtnText={t("ok")}
        cancelBtnText={t("cancel")}
      >
        {alert.content}
      </SweetAlert>
      <Portal
        show={showModal}
        values={campaign.selected}
        readOnly={!isUpdateAllowed}
      />
      <Table>
        <thead>
          <tr>
            {tableHeader.map((item) => (
              <th scope="col" style={{ whiteSpace: "nowrap" }}>
                {t(item.key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {campaignList.map((campaign) => {
            return (
              <tr>
                <td>
                  <ActionDropdown
                    campaign={campaign}
                    setShowModal={setShowModal}
                    setAlert={setAlert}
                    isUpdateAllowed={isUpdateAllowed}
                  />
                </td>
                <td>{campaign._id}</td>
                <td style={{ whiteSpace: "nowrap" }}>{campaign.name}</td>
                <td>
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {`(${t("profile.campaigns.from")}) ${moment(
                      campaign.from
                    ).format("YYYY-MM-DD")}`}
                  </tr>
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {`(${t("profile.campaigns.to")}) ${moment(
                      campaign.to
                    ).format("YYYY-MM-DD")}`}
                  </tr>
                </td>
                <td>
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {`(${t("profile.campaigns.from")}) ${
                      campaign.parkingFrom.split("T")[0]
                    }`}
                  </tr>
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {`(${t("profile.campaigns.to")}) ${
                      campaign.parkingTo.split("T")[0]
                    }`}
                  </tr>
                </td>
                <td>{campaign?.carpark?._id || "-"}</td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {campaign.carpark
                    ? i18n.language === "en"
                      ? campaign.carpark.name
                      : campaign.carpark.name_zh
                    : "-"}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {t(`profile.campaigns.${campaign.status}`)}
                </td>
              </tr>
            );
          })}
          {campaignList.length < 1 ? (
            <tr>
              <td colSpan={tableHeader.length} style={{ textAlign: "center" }}>
                {t("noResults")}
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>
    </div>
  );
};

export default CampaignsList;
